import { FormattedMessage, useIntl } from "react-intl";
import { LabelLangString } from "component/LabelLang/label-lang.js";
import FilesModal from "../filesModal/index.jsx";

function LoadingGif() {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/loading2.gif`}
      alt=""
      style={{ width: 80, height: "auto" }}
    />
  );
}

function DownloadButtons({
  searchDetails,
  publication,
  currentLocale,
  preparingPDFFile,
  preparingExcelFile,
  showPdfFiles,
  showExcelFiles,
  setShowPdfFiles,
  setShowExcelFiles,
  onExport,
}) {
  const intl = useIntl();
  const publicationName = LabelLangString({
    id: "name",
    currentLocale,
    defaultValue: publication?.name,
    translations: publication?.publicationTranslations,
  });

  const hasDownloads =
    searchDetails?.publicationDetailsFiles?.length > 0 ||
    searchDetails?.pdfUrl ||
    searchDetails?.excelUrl;

  if (!hasDownloads) return null;

  return (
    <div className="share-t row align-items-center">
      <div className="col-lg-4 col-6">
        <h6 className="mb-0">
          <FormattedMessage id="download-publication" />{" "}
        </h6>
      </div>
      <div className="col-lg-8 col-6">
        <div className="d-flex gap-2">
          {searchDetails?.pdfFiles?.length > 0 ? (
            <div>
              {preparingPDFFile ? (
                <LoadingGif />
              ) : (
                <img
                  loading="lazy"
                  src={process.env.PUBLIC_URL + "/image/pdf.png"}
                  alt="pdf-img"
                  height="40"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowPdfFiles(true)}
                />
              )}
              <FilesModal
                show={showPdfFiles}
                handleClose={() => setShowPdfFiles(false)}
                files={searchDetails.pdfFiles}
                type={2}
                fileUrl={searchDetails.pdfUrl}
                onExport={onExport}
                studyPeriod={searchDetails.studyPeriod}
                publicationName={publicationName}
              />
            </div>
          ) : searchDetails?.pdfUrl ? (
            <div>
              {preparingPDFFile ? (
                <LoadingGif />
              ) : (
                <button
                  type="button"
                  style={{ border: "none", backgroundColor: "transparent" }}
                  onClick={() =>
                    onExport(
                      "PDF",
                      `${searchDetails.pdfUrl.substring(1)}`,
                      `${publicationName} / ${searchDetails.studyPeriod}`
                    )
                  }
                >
                  <img
                    loading="lazy"
                    src={process.env.PUBLIC_URL + "/image/pdf.png"}
                    alt={intl.formatMessage({ id: "unnamed-file" })}
                    height="40"
                  />
                </button>
              )}
            </div>
          ) : null}

          {searchDetails?.excelFiles?.length > 0 ? (
            <div>
              <img
                loading="lazy"
                src={process.env.PUBLIC_URL + "/image/Excel.svg"}
                alt="excel-image"
                height="40"
                style={{ cursor: "pointer" }}
                onClick={() => setShowExcelFiles(true)}
              />
              <FilesModal
                show={showExcelFiles}
                handleClose={() => setShowExcelFiles(false)}
                files={searchDetails.excelFiles}
                type={1}
                fileUrl={searchDetails.excelUrl}
                onExport={onExport}
                studyPeriod={searchDetails.studyPeriod}
                publicationName={publicationName}
              />
            </div>
          ) : searchDetails?.excelUrl ? (
            <div>
              {preparingExcelFile ? (
                <LoadingGif />
              ) : (
                <button
                  type="button"
                  style={{ border: "none", backgroundColor: "transparent" }}
                  onClick={() =>
                    onExport(
                      "EXCEL",
                      `${searchDetails.excelUrl.substring(1)}`,
                      `${publicationName} / ${searchDetails.studyPeriod}`
                    )
                  }
                >
                  <img
                    loading="lazy"
                    src={process.env.PUBLIC_URL + "/image/Excel.svg"}
                    alt={intl.formatMessage({ id: "unnamed-file" })}
                    height="40"
                  />
                </button>
              )}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default DownloadButtons;
